import React from 'react'
import { l } from '@manychat/manyui'

import { FlowChartListMessageBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartListMessageBlock'

import * as styles from './ListMessageContent.styles'

interface ListMessageContentProps {
  blockData: FlowChartListMessageBlock['data']
}

export const ListMessageContent = ({
  blockData: { title, text, footer },
}: ListMessageContentProps) => {
  const isEmpty = !title && !text && !footer

  if (isEmpty) {
    return (
      <view style={styles.emptyWrapper}>
        <richtext style={styles.emptyText} text={l.translate('Add a text')} />
      </view>
    )
  }
  return (
    <>
      {Boolean(title) && <richtext style={styles.titleText} text={title} />}
      {Boolean(text) && <richtext style={styles.text} text={text} />}
      {Boolean(footer) && <richtext style={styles.footerText} text={footer} />}
    </>
  )
}
